import React, {Component} from 'react';
import {
  Modal, Alert, Button, ButtonToolbar,
  ButtonGroup, FormGroup, FormControl,
} from 'react-bootstrap';
import * as _ from 'lodash';
import FontAwesome from 'react-fontawesome';
import {SubscribeStore} from '../../stores/SubscribeStore';
import {toast, ToastContainer} from 'react-toastify';
import {Howl} from 'howler';
import {BrowserView, isIOS} from 'react-device-detect';
import './MessageNoti.css';
import MessageStore  from '../../stores/MessageStore';
const MAX_CONTENT_LEN = 15;

class MessageNoti extends Component {

  defaultProps = {
    channel_id: 'realtime_debug',
  };

  realtime = null;
  DEFAULT_OPTIONS = {
    title: '',
    content: '',
    message_type: 'info',
    options: {
      position: toast.POSITION.BOTTOM_RIGHT,
    },
  };
  howl = new Howl({
    src: [
      './audio/notifications/definite.mp3',
      './audio/notifications/definite.ogg',
    ],
    autoplay: false,
    loop: false,
    volume: 1,
  });

  partialContent = (content = '') => {
    return content.length < MAX_CONTENT_LEN
        ? content
        : content.slice(0, MAX_CONTENT_LEN - 1) + '...';
  };

  constructor(props) {
    super(props);
    this.state = {
      allowedPlay: false,
      showModal: false,
      iconClicked: false,
      messages: [
      ],
    };
    

    if(props.channelList!==undefined){
      //console.log('props',props.channelList)
      props.channelList.forEach((item,index) => {        
        let realtime = new SubscribeStore();
        realtime.subscribeChannel(item, this.handleSubscribe);
      })            
    }else if(props.channel_id!==undefined){
      this.realtime = new SubscribeStore();
      this.realtime.subscribeChannel(props.channel_id, this.handleSubscribe);
    }
  }

  handleSubscribe = (message) => {
    this.setState({
      messages: [
        ...this.state.messages,
        message.data,
      ],
    });
    console.log('data from channel ' + this.channel_id, message);

    if (message.data.content) {
      toast(<Msg
          message={message}
      />, _.merge(this.DEFAULT_OPTIONS, message.data.options));

      if(this.props.onNewMessage!==undefined){
        this.props.onNewMessage()
      }
    }
  };

  allowNotificationSound = () => {
    this.howl.load();
    this.setState({
      allowedPlay: true,
    });
  };

  renderAllowNotificationSound() {
    return (
        <BrowserView device={isIOS}>
          {!this.state.allowedPlay ?
              <Button className='allow-play-sound' onClick={this.allowNotificationSound}>
                Allow Play
                Sound
              </Button>
              : ''}
        </BrowserView>
    );
  }

  render() {
    return (
        <div>
          {/* {this.renderAllowNotificationSound()} */}
          <ToastContainer />
        </div>
    );
  }
}

class Msg extends Component {

  sound = null;
  DEFAULT_SOUND = {
    src: [
      '/audio/notifications/definite.mp3',
      '/audio/notifications/definite.ogg',
    ],
    autoplay: true,
    loop: false,
    volume: 1,
  };

  constructor(props) {
    super(props);

    let sound_setting = this.DEFAULT_SOUND;
    try {
      sound_setting = _.merge(this.DEFAULT_SOUND, props.message.data.sound);
      this.sound = new Howl(sound_setting);
      this.sound.play();
    } catch (ex) {
      console.log('sound setting invalid', ex);
    }
  }

  renderInfoMessage() {
    let {data} = this.props.message
    if(data.content_type!==undefined && data.content_type==='image'){
      return (
        <div className="MessageNoti">
          <strong>{this.props.message.data.title}</strong>
           <div >
  	  	  	  <div style={{position:'relative'}}>
  	  	  	    <div style={{borderRadius:'8px',backgroundImage:'url('+data.content+')',backgroundPosition:'50% 50%',backgroundRepeat:'no-repeat',height:'54px',width:'54px',backgroundSize:'cover'}}></div>  	  	  	    
  	  	  	  </div>  
  	  	  </div>
        </div>
      );
    }
    return (
        <div className="MessageNoti">
          <strong>{this.props.message.data.title}</strong>
          <p style={{
            wordBreak: 'break-all',
          }}>{this.props.message.data.content}</p>
          {/*<div className="pull-right">
            <Button onClick={this.props.closeToast}>Close</Button>
          </div>*/}
        </div>
    );
  }

  renderConfirmMessage() {
    return (
        <div className="MessageNoti">
          <strong>{this.props.message.data.title}</strong>
          <p>{this.props.message.data.content}</p>
          <div className="pull-right">
            <ButtonGroup>
              <Button bsStyle="success"
                      onClick={this.onConfirmAction}>OK</Button>
              <Button bsStyle="danger"
                      onClick={this.onCancelAction}>Cancel</Button>
            </ButtonGroup>
          </div>
        </div>
    );
  }

  renderPromptMessage() {
    return (
        <div className="MessageNoti">
          <strong>{this.props.message.data.title}</strong>
          <p>{this.props.message.data.content}</p>
          <FormGroup>
            <FormControl
                type="text"
                inputRef={ref => {this.prompt_data = ref;}}
                placeholder={this.props.message.data.placeholder}
            />
          </FormGroup>
          <ButtonGroup>
            <Button bsStyle="default"
                    onClick={this.doAction.bind(this,
                        this.props.message.data.message_options)}>Submit</Button>
          </ButtonGroup>
        </div>
    );
  }

  renderButtonsMessage() {
    let {data} = this.props.message
    if(data.content_type!==undefined && data.content_type==='image'){
      return (
        <div className="MessageNoti">
          <strong>{this.props.message.data.title}</strong>
           <div >
  	  	  	  <div style={{position:'relative'}}>
  	  	  	    <div style={{borderRadius:'8px',backgroundImage:'url('+data.content+')',backgroundPosition:'50% 50%',backgroundRepeat:'no-repeat',height:'54px',width:'54px',backgroundSize:'cover'}}></div>  	  	  	    
  	  	  	  </div>  
  	  	  </div>
          <div className="pull-right">
            <ButtonGroup>
              {this.props.message.data.message_buttons.map(
                  (item, key) => this.renderButton(item, key))}
            </ButtonGroup>
          </div>
        </div>
      );
    }
    return (
        <div className="MessageNoti">
          <strong>{this.props.message.data.title}</strong>
          <p>{this.props.message.data.content}</p>
          <div className="pull-right">
            <ButtonGroup>
              {this.props.message.data.message_buttons.map(
                  (item, key) => this.renderButton(item, key))}
            </ButtonGroup>
          </div>
        </div>
    );
  }

  renderButton = (item, key) => {
    return (
        <Button key={key}
                bsStyle={item.style}
                onClick={this.doAction.bind(this, item.action)}>
          {item.text}
        </Button>
    );
  };

  doAction = (action) => {
    switch (action.type) {
      case 'api':
        console.log('do action api', action.url, 'with options',
            action.options);
        let fetch_options = _.merge({
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
        }, action.options);

        if (this.props.message.data.message_type === 'prompt') {
          action.data = _.merge(action.data, {
            prompt: this.prompt_data.value,
          });
        }

        fetch_options.body = JSON.stringify(action.data);
        fetch(action.url, fetch_options);
        break;
      case 'bigfix_api':
        MessageStore.postApi(action.url,action.data,()=>{
          //Ok
        },()=>{

        })
        break;  
      case 'open_work':
        if(action.data.work_no!==undefined && action.data.work_no!==''){
          let workNo = action.data.work_no
          if (process.env.NODE_ENV == "development") {
            alert('show_work_doc:'+workNo)
          }else{
            if(window.show_work_doc!==undefined)
              window.show_work_doc(workNo,'#tab_wd10')
          }
        }
        break;
      case 'open_po':
          if(action.data.po_no!==undefined && action.data.po_no!==''){
            let poNo = action.data.po_no
            if (process.env.NODE_ENV == "development") {
              alert('show_work_doc:'+poNo)
            }else{
              if(window.$!==undefined){
                let api = window.$('a[href="#link_page_purchase"]').attr("data-api");
                let poApi = api + "?po=" + poNo
                window.$('a[href="#link_page_purchase"]').attr("data-api",poApi);
                window.$('a[href="#link_page_purchase"]').trigger('click');
                window.$('a[href="#link_page_purchase"]').attr("data-api",api);
              }
              if(window.show_po_doc!==undefined)
                window.show_po_doc(poNo)
            }
          }
          break;  
      default:
        console.log('unknown confirm action');
        break;
    }
    this.props.closeToast();
  };

  onConfirmAction = (data) => {
    const options = this.props.message.data.message_options;
    if (!options.onConfirm) {
      console.log('onConfirm not set, just close notification');
      return this.props.closeToast();
    }

    console.log('run onConfirm action', options.onCancel);
    return this.doAction(options.onConfirm);
  };

  onCancelAction = (data) => {
    const options = this.props.message.data.message_options;
    if (!options.onCancel) {
      console.log('onCancel not set, just close notification');
      return this.props.closeToast();
    }

    console.log('run onCancel action', options.onCancel);
    return this.doAction(options.onConfirm);

  };

  render() {
    switch (this.props.message.data.message_type) {
      case 'confirm':
        return this.renderConfirmMessage();

      case 'buttons':
        return this.renderButtonsMessage();

      case 'prompt':
        return this.renderPromptMessage();

      case 'info':
      default:
        return this.renderInfoMessage();
    }
  }
}
export default MessageNoti;



// WEBPACK FOOTER //
// ./src/view/menu/MessageNoti.js